import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { SentryService, LegalDocumentsService } from '@box-core/services';
import { environment } from '@box-env/environment';
import { APIError } from '@box-types';
import { deleteJsonLd } from '@box/utils';
import { finalize } from 'rxjs';

@Component({
  selector: 'useful-links-gdpr',
  templateUrl: './useful-links-gdpr.page.html',
  styleUrls: ['./useful-links-gdpr.page.scss']
})
export class UsefulLinksGDPRPage implements AfterViewInit, OnDestroy {
  public loading: boolean;
  public termsStylesUrl = environment.application.legalDocuments.STYLES_URL;
  public marketingTermsHtml: string;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private legalDocumentsService: LegalDocumentsService,
    private sentryService: SentryService
  ) {}

  ngAfterViewInit(): void {
    this.fetchTerms();
  }

  ngOnDestroy(): void {
    deleteJsonLd();
  }

  private fetchTerms(): void {
    this.loading = true;
    this.changeDetectorRef.detectChanges();
    this.legalDocumentsService
      .fetchMarketingTerms()
      .pipe(
        finalize(() => {
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        })
      )
      .subscribe({
        next: (terms) => (this.marketingTermsHtml = terms),
        error: (error: APIError) =>
          this.sentryService.captureException(error, {
            domain: 'Legal Documents',
            domainDetails: 'Fetch Marketing Terms Document',
            severity: 'warning'
          })
      });
  }
}
